import ReactDOM from "react-dom";
import React from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";

import { ThemeModeProvider } from "./theme/ThemeModeContext";

ReactDOM.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <HashRouter>
        <App />
      </HashRouter>
    </ThemeModeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
